import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TranslationService } from '../../../core/i18n/translation.service';

@Component({
  selector: 'app-checklist-item-definition-number-with-unit',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './checklist-item-definition-number-with-unit.component.html',
  styleUrl: './checklist-item-definition.shared.css',
})
export class ChecklistItemDefinitionNumberWithUnitComponent {
  readonly form = input.required<FormGroup>();
  readonly buckets = input.required<FormArray>();
  readonly i18n = input.required<TranslationService>();
  readonly isReadOnly = input(false);
  readonly addBucketRequested = input.required<() => void>();
  readonly removeBucketRequested = input.required<(index: number) => void>();

  protected asFormGroup(control: unknown): FormGroup {
    return control as FormGroup;
  }
}
